import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CertificatesModel } from '@models/certificates.model';
import { CertificateActions } from '@states/certificate/certificate.action-types';

export interface CertificateState extends EntityState<CertificatesModel.Document> {
  isLoading: boolean;
  isLastPage: boolean;
  page: number;
  limit: number;
}

export const certificateAdapter: EntityAdapter<CertificatesModel.Document> =
  createEntityAdapter<CertificatesModel.Document>({
    selectId: (document: CertificatesModel.Document) => document.id,
  });

const initialState: CertificateState = certificateAdapter.getInitialState({
  isLoading: true,
  isLastPage: false,
  page: 1,
  limit: CertificatesModel.PAGE_LIMIT,
});

export const certificateStateReducer = createReducer(
  initialState,
  on(CertificateActions.resetToInitialState, (state) => {
    return {
      ...initialState,
    };
  }),
  on(CertificateActions.getCertificatesSuccess, (state, { documents, page, limit }) => {
    const totalLength = documents.length;
    const currentPage = Number(page);

    if (!totalLength) {
      return certificateAdapter.setAll(documents, {
        ...state,
        isLoading: false,
        isLastPage: true,
        page: currentPage + 1,
        limit,
      });
    } else {
      return certificateAdapter.addMany(documents, {
        ...state,
        isLoading: false,
        isLastPage: documents.length < CertificatesModel.PAGE_LIMIT,
        page: currentPage + 1,
        limit,
      });
    }
  }),
  on(CertificateActions.beforeGetCertificates, (state) => {
    return certificateAdapter.removeAll({
      ...state,
      isLoading: initialState.isLoading,
      isLastPage: initialState.isLastPage,
      page: initialState.page,
    });
  }),
  on(CertificateActions.setCertificatesLoader, (state, { loading }) => {
    return {
      ...state,
      isLoading: loading,
    };
  }),
  on(CertificateActions.getCertificatesLogsFail, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
);
